import React from 'react';

const EmptyContent = ({ emptyText }) => {
  return (
    <div className={'empty-wrapper'}>
      <p className={'empty-txt'}>{emptyText}</p>
    </div>
  );
};

export default EmptyContent;
